import React from 'react';
import Header from '../Header';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import SwitchPortsTable from '../tables/distro/SwitchPortsTable';
import AccessSwitchTable from '../tables/access-switch/AccessSwitchTable';
import BrokenLinkPage from './BrokenLinkPage';
import { useUserContext } from '../../context/userConext';
import { UserPermissionsType } from '../../types/authTypes';
import { useRequiredSearchParams } from '../../hooks/useRequiredSearchParams';
import { useParams } from 'react-router-dom';
import { DistroNameDataType } from '../../types/buildingTypes';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import pageStyles from './pageStyles';

function AccessSwitchesPage() {
  const { access_switch } = useParams<DistroNameDataType>();
  const { params, isValid } = useRequiredSearchParams(['region', 'building', 'vendor', 'site']);
  const { user_permissions } = useUserContext();

  const hasPermissionsToPerformPortActions = (permissions: UserPermissionsType): boolean => {
    return (
      (permissions.port_bounce_action_permission ||
        permissions.limited_port_bounce_action_permission) &&
      (permissions.limited_port_flip_action_permission || permissions.port_flip_action_permission)
    );
  };

  if (!isValid || !access_switch) return <BrokenLinkPage />;

  return (
    <>
      <Header />
      <Box sx={{ margin: 'auto', width: '90%' }}>
        <Box sx={pageStyles.dynamicBreadcrumbs}>
          <DynamicBreadcrumbs />
        </Box>
        <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
          Access switch manager - Region: {params.region}
        </Typography>
        {hasPermissionsToPerformPortActions(user_permissions) ? (
          <AccessSwitchTable
            device="switch"
            deviceIP={access_switch}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            selectedVendor={params.vendor}
            selectedSite={params.site}
            unlimitedPortBounce={user_permissions.port_bounce_action_permission}
            unlimitedPortFlip={user_permissions.port_flip_action_permission}
          />
        ) : (
          <SwitchPortsTable
            device="switch"
            deviceIP={access_switch}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            selectedVendor={params.vendor}
            selectedSite={params.site}
          />
        )}
      </Box>
    </>
  );
}

export default AccessSwitchesPage;
